import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { toast } from 'react-toastify';
import classes from './profile.module.scss';
import InputField from '../../../_common/Form/TextFields/InputField';
import Button from '../../../_common/Form/Buttons/Button';
import utils from '../../../../utils/utils';
import { sentEditProfileUserRequest } from '../../../../store/actions/team';
import accountHelpers from '../../../../utils/accountHelpers';
import avatar from '../../../../assets/icons/avatar.png';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import Checkbox from '../../../_common/Form/Checkbox/Checkbox';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/delete.svg';
import { ReactComponent as GoogleIcon } from '../../../../assets/icons/google.svg';
import AddNewCardModal from './AddNewCardModal/AddNewCardModal';
import DeleteCardModal from './DeleteCardModal/DeleteCardModal';
import { getOnePatient } from '../../../../store/actions/patients';
import { CardIcon } from '../../../../utils/data/data';
import Loader from '../../../_common/Loader/Loader';
import api from '../../../../api/api';

const inputData = [
  {
    name: 'Full Name',
    path: 'name',
  },
  {
    name: 'Title',
    path: 'title',
  },
  {
    name: 'Username',
    path: 'username',
  },

];

const inputDataNotAll = [
  {
    name: 'Phone',
    path: 'phone',
  },
  {
    name: 'Fax',
    path: 'fax',
  },
  {
    name: 'Email',
    path: 'email',
  },
];

const inputDataNotPatient = [
  {
    name: 'Email',
    path: 'email',
  },
  {
    name: 'Name',
    path: 'name',
  }, {
    name: 'Phone',
    path: 'phone',
  },

];

const status = [
  {
    name: 'Received',
    path: 'notifyReceived',
  },
  {
    name: 'Process',
    path: 'notifyProcess',
  },
  {
    name: 'Prior Authorization',
    path: 'notifyPriorAuth',
  },
  {
    name: 'Copay Assistance',
    path: 'notifyCopayAssistance',
  },
  {
    name: 'Shipped',
    path: 'notifyShipped',
  },
];

const pay = [
  {
    id: 1,
    type: 'visa',
    number: '**** **** **** 1234',
  },
  {
    id: 2,
    type: 'visa',
    number: '**** **** **** 4568',
  }, {
    id: 3,
    type: 'visa',
    number: '**** **** **** 1987',
  },
];

const TeamProfile = () => {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { patient: { authorizeNet, profileId } } = useSelector((store) => store.patients);

  const {
    email, fax, id, name,
    notifyCopayAssistance,
    notifyPriorAuth, notifyProcess,
    notifyReceived, notifyShipped, phone, title, username,
    patientId, accessToken,
  } = accountHelpers.getUser();

  const [requiredError, setRequiredError] = useState({
    email: '',
    username: '',
  });

  const [errorMassages, setErrorMessages] = useState('');
  const [requestData, setRequestData] = useState({
    id: id || '',
    email: email || '',
    username: username || '',
    name: name || '',
    title: title || '',
    phone: phone || '',
    fax: fax || '',
    notifyReceived: !!notifyReceived,
    notifyProcess: !!notifyProcess,
    notifyPriorAuth: !!notifyPriorAuth,
    notifyCopayAssistance: !!notifyCopayAssistance,
    notifyShipped: !!notifyShipped,
    image: null,

  });

  const [buttonLoad, setButtonLoad] = useState(false);
  const [isOpenNewCardModal, setOpenNewCardModal] = useState(false);
  const [deletedCardId, setDeletedCardId] = useState(null);
  const [modalLoad, setModalLoad] = useState(false);
  const [loading, setLoading] = useState(true);
  const [googleOauthLoad, setGoogleOauthLoad] = useState(false);

  const inputDataNot = isPatient ? inputDataNotPatient : inputDataNotAll;

  const getPatient = async () => {
    await dispatch(getOnePatient({ patientId, userId: id }));

    setLoading(false);
  };

  useEffect(() => {
    if (isPatient) {
      getPatient();
    }
  }, []);

  const editUserChange = (value, path) => {
    setRequestData((prev) => ({ ...prev, [path]: value }));

    if (path !== 'name') {
      setRequiredError((prev) => ({ ...prev, [path]: '' }));
    }
  };

  const submitEditProfile = async (e) => {
    e.preventDefault();
    setButtonLoad(true);
    if (!requestData.email || !requestData.username) {
      _.forEach(requestData, (val, key) => {
        if ((!val) && (key !== 'name' && key !== 'active')) {
          setRequiredError((prev) => ({ ...prev, [key]: 'Please fill this fields' }));
        }
      });
    }

    if (!utils.isEmail(requestData.email)) {
      setRequiredError((prev) => ({ ...prev, email: 'You have entered an invalid email address' }));
      return;
    }
    if (requestData.username && requestData.id && requestData.email) {
      const newQuery = utils.deleteEmptyKeys(requestData);
      try {
        const data = await dispatch(sentEditProfileUserRequest(newQuery));
        if (data.status === 'ok') {
          navigate('/team');

          toast.success('User successfully updated');
        } else {
          setErrorMessages(data.payload.data.message);

          toast.error(`${data.payload.data.message}` || 'Something field error');
        }
        setButtonLoad(false);
      } catch (e) {
        console.warn(e);
      }
    }
  };

  const changeAvatar = (files) => {
    [...files].map((file) => {
      file._preview = URL.createObjectURL(file);
      setRequestData((prev) => ({ ...prev, image: file }));
    });
  };

  const deleteCard = async (idCard) => {
    setModalLoad(true);
    const deletedCard = authorizeNet.find((a) => a.customerPaymentProfileId === idCard);

    await api.deleteCard({
      profileId: deletedCard.profileId, profilePaymentId: deletedCard.customerPaymentProfileId,
    });

    getPatient();

    toast.success('Removed selected card');

    setModalLoad(false);
    setDeletedCardId(null);
  };

  const closeAddNewCardModal = () => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('width');
    document.body.ontouchmove = () => true;

    setOpenNewCardModal(false);
  };

  const saveCard = async (cardData) => {
    setModalLoad(true);
    const data = {
      cardNumber: cardData.cardNumber.replace(/ /g, ''),
      cardCVC: cardData.cardCVC.replace(/ /g, ''),
      cardExpiry: cardData.cardExpiry.replace(/\s/g, '').replace(/\//g, ''),
    };

    if (profileId) {
      data.profileId = profileId;
    } else {
      data.patientId = patientId;
    }

    await api.createCard({ ...data });

    getPatient();

    setModalLoad(false);

    setOpenNewCardModal(false);
  };

  const googleOauthClick = async () => {
    setGoogleOauthLoad(true);

    const { data } = await api.googleOauth();

    setGoogleOauthLoad(false);

    window.open(data.authUrl);
  };

  return (
    <div className={classes.team_add_wrapper}>
      <div>
        <h2>Profile</h2>

        {loading && isPatient
          ? <Loader />
          : (
            <form onSubmit={submitEditProfile}>
              <div className={classes.file}>
                <img
                  src={requestData.image?._preview ? requestData.image?._preview : accountHelpers.getUser().link}
                  alt="avatar"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avatar;
                  }}
                />

                <label htmlFor="file"><EditIcon /></label>
                <input type="file" id="file" accept=".png" onChange={(e) => changeAvatar(e.target.files)} />
              </div>

              {!isPatient && inputData.map((i) => (
                <div key={i.name}>
                  <div className={classes.add_input_wrapper}>
                    <InputField
                      label={i.name}
                      value={requestData[i.path]}
                      onChange={(value) => {
                        editUserChange(value, i.path);
                      }}
                      error={requiredError[i.path]}
                    />
                  </div>
                </div>
              ))}

              <div className={classes.changePassword}>
                <h3>Password</h3>
                <NavLink to="/account/chpass">Change Password</NavLink>
              </div>

              {inputDataNot.map((i) => (
                <div key={i.name}>
                  <div className={classes.add_input_wrapper}>
                    <InputField
                      label={i.name}
                      value={requestData[i.path]}
                      onChange={(value) => {
                        editUserChange(value, i.path);
                      }}
                      error={requiredError[i.path]}
                    />
                  </div>
                </div>
              ))}

              {!isPatient && (
              <div className={classes.checkbox_wrapper}>
                <h3>Statuses</h3>

                {status.map((s) => (
                  <div key={s.path}>
                    <Checkbox
                      label={s.name}
                      onChange={(checked) => editUserChange(checked, s.path)}
                      checked={requestData[s.path]}
                    />
                  </div>
                ))}
              </div>
              )}

              {isPatient && (
              <div className={classes.card_payment}>
                <h3>Card</h3>
                {authorizeNet.map((a) => (
                  <div key={a?.customerPaymentProfileId} className={classes.cards}>
                    <span>{CardIcon[a?.payment.creditCard.cardType]}</span>

                    <span>{a?.payment.creditCard.cardNumber}</span>

                    <span
                      role="button"
                      tabIndex="0"
                      onClick={() => setDeletedCardId(a?.customerPaymentProfileId)}
                    >
                      <DeleteIcon />
                    </span>

                  </div>
                ))}
                <p onClick={() => setOpenNewCardModal(true)}>+ Add Credit Card</p>
              </div>
              )}

              {/* <div className={classes.google_oauth_button_wrapper}> */}
              {/*  <div className={classes.google_oauth_button_label}> */}
              {/*    <GoogleIcon /> */}

              {/*    <p>Google account</p> */}
              {/*  </div> */}

              {/*  <Button */}
              {/*    title={accessToken ? 'Connected' : 'Connect'} */}
              {/*    className={classes.google_oauth_button} */}
              {/*    onClick={googleOauthClick} */}
              {/*    loading={googleOauthLoad} */}
              {/*  /> */}

              {/* </div> */}

              <div className={classes.add_button_wrapper}>
                {errorMassages && <div className={classes.error}>{errorMassages}</div>}

                <div>
                  <Button
                    title="Save"
                    type="submit"
                    reverseColor
                    loading={buttonLoad}
                  />
                </div>

                <div>
                  <Button
                    title="Cancel"
                    onClick={() => navigate(-1)}
                    clearButton
                  />
                </div>
              </div>
            </form>
          )}

      </div>

      {isOpenNewCardModal && (
        <AddNewCardModal
          onClose={closeAddNewCardModal}
          isOpen={isOpenNewCardModal}
          loading={modalLoad}
          saveCard={saveCard}
        />
      )}

      <DeleteCardModal
        isOpen={!!deletedCardId}
        onClose={() => setDeletedCardId(null)}
        onDeleteClick={() => deleteCard(deletedCardId)}
        loading={modalLoad}
      />
    </div>
  );
};

export default TeamProfile;
